import React from 'react';

interface EyebrowProps {
  children: React.ReactNode;
  /** Brighter variant legible on navy surfaces (banners). */
  light?: boolean;
  className?: string;
}

/**
 * Eyebrow micro-label — the design system's smallest text pattern.
 * 11.5px is the system-wide type floor; nothing is set smaller.
 * Supersedes MicroLabel (which now delegates here).
 */
const Eyebrow: React.FC<EyebrowProps> = ({ children, light = false, className = '' }) => (
  <span
    className={`font-sans font-semibold uppercase whitespace-nowrap ${className}`}
    style={{
      fontSize: '11.5px',
      letterSpacing: '0.14em',
      color: light ? 'rgba(255,255,255,0.65)' : 'var(--ink-500)',
    }}
  >
    {children}
  </span>
);

export default Eyebrow;
